import Axios from "axios";
var PurInService = (function () {
    function PurInService() {
    }
    PurInService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/warehouseorder/list", { params: params });
    };
    PurInService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/warehouseorder/detail", { params: params });
    };
    PurInService.prototype.getStatus = function (params) {
        return Axios.get("supplierclientapi/warehouseorder/getsupstatus", { params: params });
    };
    PurInService.prototype.confirm = function (params) {
        return Axios.post("supplierclientapi/warehouseorder/save_confirm", params);
    };
    PurInService.prototype.latestSignImg = function (params) {
        return Axios.get("supplierclientapi/warehouseorder/latest_sign_img", { params: params });
    };
    PurInService.prototype.getSignStatus = function (params) {
        return Axios.get("supplierclientapi/warehouseorder/get_sign_status", { params: params });
    };
    PurInService.prototype.getListGoods = function (params) {
        return Axios.post("supplierclientapi/warehouseorder/list_goods", params);
    };
    PurInService.prototype.createDelivery = function (params) {
        return Axios.post("supplierclientapi/warehouseorder/create_delivery", params);
    };
    PurInService.prototype.orderImgById = function (params) {
        return Axios.get("supplierclientapi/warehouseorder/order_img_list", { params: params });
    };
    PurInService.prototype.orderDetailImg = function (params) {
        return Axios.get("supplierclientapi/warehouseorder/order_detail_img_list", { params: params });
    };
    PurInService.createInstance = function () {
        PurInService.getInstance();
    };
    PurInService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    PurInService.prototype.getSignList = function (params) {
        return Axios.get("supplierclientapi/warehouseorder/sign_img_list", { params: params });
    };
    return PurInService;
}());
export default PurInService;
